<template>
	<div>
		<video class="bg-video" src="/footage/yaprakyakin.mp4" autoplay muted loop></video>
		<router-link :to="{name:'yaprak'}" class="page-nav-link" id="link-right"><img class="link-image" src="images/arrow-right-white-02.png" alt="" style="max-height: 60px;"></router-link>

	</div>
</template>

<script>
	export default {
		name: "YaprakYakinPage"
	}
</script>

<style scoped>
	.bg-video {
		top: 0;
		left: 0;
		position: absolute;
		object-fit: cover;
		width: 100%;
		height: 100%;
		z-index: -2;
	}
</style>